module.exports = __webpack_public_path__ + "img/生态环境部环境工程评估中心.585b66df.png";